import React, {useState, useEffect} from "react";
import RjsProductList from "../../../react-components/RjsProductList";
import useProductsFetcher from "../useProductsFetcher";

// This list combines the "manual_product_trends_homepage" with "trending_items".
// If the first is not enough to fill the "limitTo" spaces, the second will fill in.
const CurrentTrendsList = (props) => {
  const {limitTo} = props;
  const [products, setProducts] = useState([]);

  const {loadArbitrarySet} = useProductsFetcher();

  const fetchTrends = () => {
    loadArbitrarySet({namedSet: "trending_items", limitTo}).then(trends => {
      setProducts(trends);
    });
  };

  useEffect(() => {
    fetchTrends();
  }, []);

  return <>
    {products.length > 0 &&
      <RjsProductList
        products={products}
        hideMoreButton={true}
        {...props}
      />}
  </>;
};

export default CurrentTrendsList;
